import React from 'react';
import Link from 'next/link';
import { signIn } from 'next-auth/react';
import { EyeIcon, Input } from '@avila-tek/ui/src';
import { Button } from '@avila-tek/ui/src/Button';
import { useRouter } from 'next/router';
import { UserTypeEnum } from '../../models/index';
import { roles } from '../../static';
import { rolesTranslate } from '../../static/roles';
import { useNotify } from '../../hooks/useNotify';
import ResetPasswordModal from '../shared/ResetPasswordModal/ResetPasswordModal';

interface SignInFormProps {
  userType: UserTypeEnum;
}

function SignInForm({ userType }: SignInFormProps) {
  const router = useRouter();
  const notify = useNotify();

  const callbackUrl = (router.query?.callbackUrl as string) ?? '/';
  const [showPassword, setShowPassword] = React.useState(false);
  const [resetPasswordModalIsOpen, setResetPasswordModalIsOpen] =
    React.useState(false);

  const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const formData = new FormData(e.currentTarget);

    try {
      const { ok, error } = await signIn('credentials', {
        email: formData.get('email').toString(),
        password: formData.get('password').toString(),
        redirect: false,
        userType,
      });
      if (ok) {
        return router.push(callbackUrl as string);
      }
      notify(error, 'error');
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <>
      <h2 className="text-xl sm:text-3xl text-text-black font-semibold mx-auto">
        ¡Bienvenido de vuelta!
      </h2>
      <span className="text-sm sm:text-base text-center text-text-black">
        Inicia sesión para continuar en la plataforma de{' '}
        {rolesTranslate[userType]} de Meit!
      </span>
      <form className="space-y-5 flex flex-col" onSubmit={onSubmit}>
        <Input
          label="Correo electrónico"
          placeholder="jonhdoe@gmail.com"
          type="email"
          name="email"
          required
        />
        <Input
          label="Contraseña"
          placeholder="********"
          name="password"
          type={showPassword ? 'text' : 'password'}
          required
          rightIcon={
            <EyeIcon
              className="w-5 h-5 cursor-pointer"
              onClick={(e) => {
                e.preventDefault();
                setShowPassword(!showPassword);
              }}
            />
          }
        />
        <button
          type="button"
          onClick={(e) => {
            e.preventDefault();
            setResetPasswordModalIsOpen(true);
          }}
          className="text-purple-300 w-full text-right cursor-pointer"
        >
          ¿Olvidaste tu contraseña?
        </button>
        <Button>Ingresar</Button>
        {/* link to sign up of this user type */}
        {userType !== roles.admin ? (
          <>
            {/* link to sign in other userType  */}
            <div className="flex w-full justify-center items-center space-x-2">
              <hr className="bg-neutral-400 border-neutral-400 w-full" />
              <span className="w-full whitespace-nowrap text-neutral-400  text-center">
                ¿Eres{' '}
                {userType === roles.ally
                  ? `una ${rolesTranslate[roles.company]}`
                  : `un ${rolesTranslate[roles.ally]}`}
                ?
              </span>
              <hr className="bg-neutral-400 border-neutral-400 w-full" />
            </div>
            <Link
              href={`/sign-in/${
                userType === roles.ally ? roles.company : roles.ally
              }`}
            >
              <Button className="bg-system-300 text-purple-300 hover:bg-purple-100 hover:text-text-white">
                Iniciar sesión como{' '}
                {userType === roles.ally
                  ? rolesTranslate[roles.company]
                  : rolesTranslate[roles.ally]}
              </Button>
            </Link>
          </>
        ) : null}
      </form>
      <ResetPasswordModal
        isOpen={resetPasswordModalIsOpen}
        setOpen={setResetPasswordModalIsOpen}
      />
    </>
  );
}

export default SignInForm;
